import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表

//系统管理相关接口
const myAllWork={
//创建顺序练习题
  createSxQuestion(params){
    return axios.get(`${base.bs}/guest/examSx/createQuestion/${params.cardid}`,null);
  },
//顺序练习题个数
  getSxQnumGroupQtype(params){
    return axios.get(`${base.bs}/guest/examSx/getQnumGroupQtype/${params.cardid}/${params.havejx}`,null);
  },
//获取顺序练习题
  getSxQuestions(params){
    return axios.get(`${base.bs}/guest/examSx/getQuestions/${params.cardid}/${params.qtype}/${params.isjx}/${params.iskt}`,{params:{pdlx:params.pdlx}});
  },
//获取顺序练习题
  getQuestion(params){
    return axios.post(`${base.bs}/guest/examSx/getQuestion/${params.cardid}/${params.id}`,null);
  },
//保存顺序练习题答案
  saveSxAnswer(params){
    return axios.get(`${base.bs}/guest/examSx/saveAnswer/${params.cardid}/${params.qid}/${params.isjx}/${params.qtype}`,{params:{daid:params.daid,answer:params.answer}});
  },
//保存顺序看题记录
  saveSxKtjd(params){
    return axios.get(`${base.bs}/guest/examSx/saveKtJd/${params.cardid}/${params.qid}/${params.isjx}/${params.qtype}/${params.pdlx}`);
  },
//重置顺序答案
  resetSxlxDa(params){
    return axios.get(`${base.bs}/guest/examSx/resetSxlxDa/${params.cardid}/${params.isjx}/${params.qtype}`);
  },

}
// 导出接口
export  default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/myExamSxlx.js